import React, { KeyboardEvent, useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import MuiInputAdornment from '@material-ui/core/InputAdornment/InputAdornment';
import TextField from '@material-ui/core/TextField';
import MuiClearIcon from '@material-ui/icons/Clear';
import MuiSearchIcon from '@material-ui/icons/Search';
import {
  ApiFilterOperation,
  TableContext,
  Tooltip,
  useEventCallback,
} from '@eas/common-web';

export const UsersCustomSearchbarComponent = () => {
  const { classes, setAdvancedFilters } = useContext(TableContext);
  const [text, setText] = useState('');
  const intl = useIntl();

  const handleKeyDown = useEventCallback((e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      submit(text);
    }
  });

  const submit = useEventCallback((value: string) => {
    if (value === '') {
      setAdvancedFilters([]);
      return;
    }
    setAdvancedFilters([
      {
        operation: ApiFilterOperation.OR,
        filters: [
          {
            field: 'lastName',
            operation: ApiFilterOperation.CONTAINS,
            value,
          },
          {
            field: 'hrId',
            operation: ApiFilterOperation.CONTAINS,
            value,
          },
        ],
      },
    ]);
  });

  return (
    <div className={classes.searchBar} onKeyDown={handleKeyDown}>
      <TextField
        classes={{ root: classes.searchTextField }}
        autoComplete="off"
        id="outlined-search"
        type="search"
        value={text}
        variant="outlined"
        margin="dense"
        InputProps={{
          spellCheck: false,
          classes: {
            root: classes.searchTextFieldInput,
            input: classes.input,
          },
          endAdornment: (
            <MuiInputAdornment position="end">
              {text && (
                <Tooltip
                  title={intl.formatMessage({
                    id: 'EAS_TABLE_SEARCHBAR_BTN_CLEAR',
                    defaultMessage: 'Smazat text',
                  })}
                  placement="top-start"
                >
                  <MuiClearIcon
                    classes={{ root: classes.smallFilterIcon }}
                    onClick={() => {
                      setText('');
                      setAdvancedFilters([]);
                    }}
                    data-cy="EAS__SEARCHBAR__CLEAR"
                  />
                </Tooltip>
              )}
              <Tooltip
                title={intl.formatMessage({
                  id: 'EAS_TABLE_SEARCHBAR_BTN_SEARCH',
                  defaultMessage: 'Hledat',
                })}
                placement="top-start"
              >
                <MuiSearchIcon
                  classes={{ root: classes.searchIcon }}
                  onClick={() => submit(text)}
                  data-cy="EAS__SEARCHBAR__SEARCH"
                />
              </Tooltip>
            </MuiInputAdornment>
          ),
        }}
        onChange={(e) => setText(e.target.value)}
      />
    </div>
  );
};
